import { Field } from 'formik';
import * as React from 'react';

import { TextFieldProps } from './types';
import ErrorMessage from '../ErrorMessage';
import muiStyles from '../fieldStyles';

export default function TextFieldComponent(props: TextFieldProps) {
    const {
        id,
        testId,
        fieldSize,
        name,
        label,
        placeholder,
        type,
        disabled,
        maxLength,
        customOnChange,
        errors
    } = props;

    const classes = muiStyles(props);

    return (
        <Field
            name={name}
        >
            {({ field, form }) => (
                <div className={classes.field}>
                    {label && (
                        <label
                            className={fieldSize === 'large' ? classes.inputLabelLarge : classes.inputLabel}
                            htmlFor={name}
                        >
                            {label}
                        </label>
                    )}
                    <div className={classes.inputContainer}>
                        <input
                            {...field}
                            className={fieldSize === 'large' ? classes.textInputLarge : classes.textInput}
                            data-testid={testId ? testId : ''}
                            disabled={disabled}
                            id={id ? `${id}_input` : ''}
                            maxLength={maxLength || 255}
                            name={name}
                            onChange={(e) => {
                                if (!form.touched[name]) {
                                    form.setFieldTouched(name, true);
                                }

                                if (customOnChange) {
                                    customOnChange(e);
                                } else {
                                    field.onChange(e);
                                }
                            }}
                            placeholder={placeholder}
                            type={type || 'text'}
                        />
                    </div>
                    <ErrorMessage
                        error={errors[field.name]}
                        field={field}
                        form={form}
                        id={id || ''}
                    />
                </div>
            )}
        </Field>
    );
}